import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

interface ConfirmActionProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
  header: string;
  message: React.ReactNode;
  confirmLabel?: string;
  loading?: boolean;
}

const ConfirmActionPopup: React.FC<ConfirmActionProps> = ({
  visible,
  onHide,
  onConfirm,
  header,
  message,
  confirmLabel = "Confirm",
  loading = false,
}) => {
  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={visible}
        breakpoints={{ "960px": "75vw", "640px": "90vw" }}
        style={{ width: "30vw", maxWidth: "90vw" }}
        draggable={false}
        onHide={onHide}
        header={header}
        footer={
          <>
            <Button
              label="Cancel"
              className="p-button-text cancle-btn"
              onClick={onHide}
              disabled={loading}
            />
            <Button
              label={confirmLabel}
              severity="success"
              onClick={onConfirm}
              loading={loading}
            />
          </>
        }
        modal
        closable={false}
      >
        <div>{message}</div>
      </Dialog>
    </div>
  );
};

export default ConfirmActionPopup;
